import { Button, Modal } from "antd";
import { FileUp } from "lucide-react";
import { useState } from "react";
import { CreateNotification } from "../../../../../../components/notifier";
import { BusinessTicketRequestService } from "../../../../../../services/company-office/BusinessTicketService";
import { Upload } from "../../../../upload";

interface UploadFileProps {
  data: any;
}

const UploadFile = (props: UploadFileProps) => {
  const { data } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleShowModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setUploadedFiles([]);
    setIsModalOpen(false);
  };

  const handleFileChange = (files: any[]) => {
    setUploadedFiles(files);
  };

  const handleTouched = () => {
    // No-op handler for form validation
  };

  const handleUploadFiles = async () => {
    setIsLoading(true);

    try {
      await BusinessTicketRequestService.updateBusinessTicketRequest(data.id, {
        eFileContent: JSON.stringify([...(JSON.parse(data.eFileContent || "[]") || []), ...uploadedFiles]),
      }).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Tải tài liệu thành công.`,
            icon: "/icons/success.png",
          });

          handleCloseModal();
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Tải tài liệu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        style={{
          borderRadius: ".25rem",
        }}
        icon={<FileUp size={16} />}
        onClick={handleShowModal}
      />

      <Modal
        destroyOnClose
        width={800}
        title={`Bổ sung tài liệu cho ${data.Title.toLowerCase()} ${data.id}`}
        open={isModalOpen}
        onCancel={handleCloseModal}
        maskClosable={false}
        okText="Tải lên"
        cancelText="Hủy"
        onOk={handleUploadFiles}
        okButtonProps={{
          disabled: uploadedFiles.length === 0,
          loading: isLoading,
        }}
        cancelButtonProps={{
          disabled: isLoading,
        }}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Upload name="upload-files" value={uploadedFiles} onChange={handleFileChange} onTouched={handleTouched} />
        </div>
      </Modal>
    </div>
  );
};

export default UploadFile;
